// Default options for our keyFigures. Valid dashStyles are Solid,
// ShortDash, ShortDot, ShortDashDot, ShortDashDotDot, Dot, Dash,
// LongDash, DashDot, LongDashDot, LongDashDotDot
const borderWidth = 2;
const lineWidth = 3;

export default {
	Default: {
		color: "black",
		borderColor: "black",
		borderWidth,
		lineWidth,
		dashStyle: "solid",
		marker: { symbol: "circle" },
	},
	AccountsReceivables: { color: "#c5c5c5", borderColor: "#fb38d9" },
	AccountsReceivablesToNetSalesRatio: {
		color: "#fb38d9",
		dashStyle: "shortdot",
	},
	AdjustedEquity: { color: "#ffea00" },
	AdjustedLiabilities: { color: "#1c00c4" },
	AdministrativeExpenses: { color: "#e21c1c", borderColor: "#626262" },
	AdministrativeExpensesToNetSalesRatio: {
		color: "#880000",
		dashStyle: "longdot",
	},
	AllocationsAndProvisions: { color: "#110078" },
	Appropriations: { color: "#89a388" },
	Assets: { color: "#4d4d4d", borderColor: "#808080" },
	// AssetsOpeningBalance - blacklisted
	BankOverdraft: { color: "#14d6dd" },
	BankOverdraftLimit: { color: "#14d6dd" },
	CapitalEmployed: { color: "#00c494" },
	CapitalTurnOverRate: { color: "#7b7b7b" },
	ChangeInAssets: {
		color: "black",
		dashStyle: "dot",
		marker: { symbol: "triangle" },
	},
	ChangeInEquityCapital: {
		color: "#ffea00",
		dashStyle: "dot",
		marker: { symbol: "triangle" },
	},
	ChangeInNetSales: {
		color: "black",
		dashStyle: "solid",
		marker: { symbol: "triangle" },
	},
	ChangeInNumberOfEmployees: { color: "#9e0000", dashStyle: "shortdash" },
	ChangeInRefinementValue: { color: "#976303" },
	ChangeInRefinementValuePerEmployee: {
		color: "#976303",
		dashStyle: "longdash",
	},
	Cost: { color: "#ff6430" },
	CostsBeforeAppropriations: { color: "#d63e37" },
	CostsBeforeCostsForEmployees: { color: "#e21c1c" },
	CostsBeforeExtraordinaryIncomeAndExpenses: {
		color: "#9e0000",
		borderColor: "green",
	},
	CostsBeforeFinancial: { color: "#f3463e" },
	CostsBeforeImpairmentsAndWriteBack: { color: "#ff5050" },
	CostsBeforeOperatingExpenses: { color: "#b20000" },
	CostsBeforeProfitEntries: { color: "#ac2821" },
	CostsBeforeTaxes: { color: "#9e0000", borderColor: "grey" },
	CostsForEmployees: { color: "#ff5050" },
	CostsForEmployeesPerEmployee: {
		color: "#ff5050",
		borderColor: "#9e0000",
	},
	CostsForEmployeesToNetSalesRatio: {
		color: "#db3a3a",
		dashStyle: "shortdash",
	},
	CostsForEmployeesToRefinementValueRatio: {
		color: "#ff5050",
		dashStyle: "longdash",
	},
	CostsForResearchAndDevelopment: { color: "#a50042" },
	CostsForResearchAndDevelopmentToNetSalesRatio: {
		color: "#db3a3a",
		dashStyle: "longdot",
	},
	CostsOfPremisesAndProperty: {
		color: "#e21c1c",
		borderColor: "#b4b4b4",
	},
	CostsOfPremisesAndPropertyToNetSalesRatio: {
		color: "#bf0000",
		dashStyle: "longdot",
	},
	Coverage: { color: "#cdbb75" },
	CoveragePerEmployee: { color: "#f0ed00", borderColor: "#9e0000" },
	CoverageRatio: { color: "#f0ed00", dashStyle: "longdashdotdot" },
	CreditPeriodAccountsReceivables: { color: "#fb38d9" },
	CreditSalesVATIncluded: { color: "#555555" },
	CurrentAssets: { color: "#a7a7a7" },
	CurrentInvestmentsAndLiquidFunds: {
		color: "#e3e3e3",
		borderColor: "red",
	},
	CurrentInvestmentsAndLiquidFundsToNetSalesRatio: {
		color: "red",
		dashStyle: "shortdot",
	},
	CurrentLiabilities: { color: "#006cff" },
	CurrentLiabilitiesToNetSalesRatio: {
		color: "#006cff",
		dashStyle: "shortdot",
	},
	CurrentRatioUntappedBankOverdraftIncluded: {
		color: "purple",
		dashStyle: "shortdash",
	},
	DebtInterest: { color: "#0015ff" },
	DeferredTaxLiability: { color: "#63c2ff" },
	DeprecationsAccordingToPlan: { color: "#fb247a" },
	DeprecationsToNetSalesRatio: {
		color: "#fb247a",
		dashStyle: "shortdot",
	},
	EquityCapital: { color: "#ffea00" },
	EquityCapitalAndLiabilities: {
		color: "#006cff",
		borderColor: "#ffea00",
	},
	EquityCapitalToNetSalesRatio: {
		color: "#ffea00",
		dashStyle: "shortdot",
	},
	EquityCapitalWithPreliminaryResults: { color: "#ffea00" },
	EquityRatio: { color: "purple" },
	ExtraordinaryIncomeAndExpenses: { color: "#5aff00" },
	Financial: { color: "#668033" },
	FinancialAssets: { color: "#989898", borderColor: "green" },
	FinancialAssetsToNetSalesRatio: {
		color: "#aadaa2",
		dashStyle: "shortdot",
	},
	FinancialCosts: { color: "#00921b", borderColor: "#e21c1c" },
	FinancialIncome: { color: "#00921b" },
	FinancialItemsToNetSalesRatio: {
		color: "#00921b",
		dashStyle: "shortdot",
	},
	FixedAssets: { color: "#5c5c5c", borderColor: "#0090ff" },
	GoodsForResale: { color: "#B20000", borderColor: "#f0f718" },
	GoodsForResaleAndRawMaterial: {
		color: "#B20000",
		borderColor: "#95cd27",
	},
	GrossProfit: { color: "#483d01" },
	GrossProfitMargin: { color: "#976303", dashStyle: "ShortDashDot" },
	GrossProfitPerEmployee: { color: "#d68b01", borderColor: "#9e0000" },
	ImpairmentsAndWriteBack: { color: "#a50042" },
	Income: { color: "#424242", borderColor: "#45a92e" },
	IncomeBeforeFinancial: {
		color: "black",
		dashStyle: "solid",
		borderColor: "#676767",
	},
	IndebtednessRatio: { color: "#001d53" },
	IntangibleAssetsToNetSalesRatio: {
		color: "#e9e8e8",
		dashStyle: "shortdot",
	},
	IntangibleFixedAssets: { color: "#6b6b6b", borderColor: "yellow" },
	InterestBearingLiabilities: {
		color: "#1c00c4",
		borderColor: "#b239e4",
	},
	InterestCoverRatio: { color: "#006400" },
	Inventory: { color: "#b6b6b6", borderColor: "#b438fb" },
	InventoryToNetSalesRatio: { color: "#e3b2ff", dashStyle: "shortdot" },
	InventoryTurnover: { color: "#ce6100" },
	InventoryYield: { color: "#ce6100" },
	InvestmentsInPropertyPlantAndEquipmentForTheYear: { color: "#898989" },
	InvestmentsInPropertyPlantAndEquipmentToNetSalesRatio: {
		color: "#898989",
		dashStyle: "shortdot",
	},
	ItemsAffectingComparability: { color: "#e78db1" },
	LandsAndBuildings: { color: "#7a7a7a", borderColor: "green" },
	LiquidCurrentAssets: { color: "#e3e3e3", borderColor: "red" },
	LiquidRatio: { color: "purple", dashStyle: "shortdash" },
	LoanRate: { color: "#0015ff", dashStyle: "longdash" },
	LoanRatio: { color: "#001d53", borderColor: "#00c0ff " },
	LongTermLiabilities: { color: "#1c00c4", borderColor: "#022b52" },
	LongTermLiabilitiesAndAllocationsToNetSalesRatio: {
		color: "#110078",
		dashStyle: "shortdot",
	},
	MachineryAndEquipment: { color: "#898989", borderColor: "#00fff6" },
	MachineryAndEquipmentToNetSalesRatio: {
		color: "#b9b9b9",
		dashStyle: "shortdot",
	},
	MaterialFixedAssetsToNetSalesRatio: {
		color: "#d0d0d0",
		dashStyle: "shortdot",
	},
	NetMargin: { color: "black", dashStyle: "shortdash" },
	NetOperatingIncomeEbit: { color: "#a08801" },
	NetOperatingIncomeEaitb: { color: "#faf6aa" },
	NetSales: { color: "black" },
	NetSalesPerEmployee: { color: "#960000", dashStyle: "dot" },
	NFGrossProfitMarginServices: { color: "black", dashStyle: "ShortDashDot" },
	NonCurrentLiabilities: { color: "#1c00c4", borderColor: "#b3b3b3" },
	NonCurrentLiabilitiesAndBankOverdraft: { color: "#1c00c4" },
	NonRestrictedEquityCapital: {
		color: "#ffea00",
		borderColor: "#31ea0c",
	},
	NumberOfEmployees: { color: "#9e0000" },
	OperatingExpenses: { color: "#e21c1c" },
	OperatingMargin: { color: "black", dashStyle: "shortdashdot" },
	OtherCostsForEmployees: { color: "#ff5050", borderColor: "#b4b4b4" },
	OtherCurrentReceivables: { color: "#d4d4d4", borderColor: "#001d88" },
	OtherCurrentReceivablesToNetSalesRatio: {
		color: "#001d88",
		dashStyle: "shortdot",
	},
	OtherOperatingExpenses: { color: "#e21c1c" },
	OtherOperatingExpensesToNetSalesRatio: {
		color: "#ffa053",
		dashStyle: "longdot",
	},
	OtherOperatingIncome: { color: "#2a2a2a" },
	OtherSellingExpenses: { color: "#faf6aa" },
	Profit: { color: "#9ec94f" },
	// PreliminaryResult - blacklisted!
	PreviousPreliminaryResult: { color: "#dab901" },
	// Profit = OLD, not used, see ResultAfterAllItems. Profit: { color: 'orange' },
	ProfitAfterDeprecations: { color: "#746200" },
	ProfitAfterFinancialItemsPerEmployee: {
		color: "#8a5b00",
		borderColor: "#fff600",
	},
	ProfitBeforeFinancialItemsPerEmployee: {
		color: "#9e0000",
		borderColor: "#fff600",
	},
	// ProfitEntryAccounts - blacklisted!
	ProfitMargin: { color: "black", dashStyle: "longdash" },
	PropertyCosts: { color: "#a08801" },
	PurchaseOfGoodsAndEquipment: { color: "#b20000" },
	QuickRatioUntappedBankOverdraftIncluded: {
		color: "#800080",
		dashStyle: "shortdashdot",
	},
	RawMaterial: { color: "#B20000", borderColor: "#1891f7" },
	RefinementRatio: { color: "#976303" },
	RefinementValue: { color: "#ffef98" },
	RefinementValuePerEmployee: { color: "#976303" },
	RestrictedEquityCapital: { color: "#ffea00", borderColor: "#ea0c0c" },
	ResultAfterAllItems: { color: "#fec004", borderColor: "#fec004" },
	ResultAfterFinancialItems: { color: "#dab901" },
	ResultBeforeFinancialCosts: { color: "#a08801" },
	ReturnOnAssets: { color: "#ffea00", dashStyle: "longdash" },
	ReturnOnCapitalEmployed: { color: "#e6d300" },
	ReturnOnEquity: { color: "#ffea00" },
	RiskBufferCapital: { color: "#b1a200" },
	RiskBufferOnCapitalEmployed: {
		color: "#e6d300",
		dashStyle: "longdash",
	},
	SalariesSocialBenefitsEtc: { color: "#ff5050" },
	SellingExpenses: { color: "#e21c1c", borderColor: "#7b7b7b" },
	SellingExpensesToNetSalesRatio: {
		color: "#fe0000",
		dashStyle: "longdot",
	},
	SeparableCosts: { color: "#a72a2a" },
	Taxes: { color: "dimgray" },
	// Turnover is just an alias for IncomeBeforeFinancial - blacklisted!
	UntaxedReserves: { color: "#ffea00", borderColor: "#0084ff" },
	UntaxedReservesToNetSalesRatio: {
		color: "#0084ff",
		dashStyle: "shortdot",
	},
	WorkingCapital: { color: "#c5c5c5", borderColor: "#6db5ff" },
	WorkingCapitalToNetSalesRatio: { color: "#7b7b7b" },

	//
	// LRFK Zero Account KPIs
	//

	LRFK0301: { color: "dimgray" },
	LRFK0302: { color: "dimgray" },
	LRFK0303: { color: "dimgray" },
	LRFK0304: { color: "dimgray" },
	LRFK0305: { color: "dimgray" },
	LRFK0311: { color: "dimgray" },
	LRFK0321: { color: "dimgray" },
	LRFK0361: { color: "dimgray" },
	LRFK0401: { color: "dimgray" },
	LRFK0402: { color: "dimgray" },
	LRFK0403: { color: "dimgray" },
	LRFK0405: { color: "dimgray" },
	LRFK0416: { color: "dimgray" },
	LRFK0601: { color: "dimgray" },
	LRFK0620: { color: "dimgray" },
	LRFK0622: { color: "dimgray" },
	LRFK0623: { color: "dimgray" },
	LRFK0624: { color: "dimgray" },
	LRFK0625: { color: "dimgray" },
	LRFK0626: { color: "dimgray" },
	LRFK0651: { color: "dimgray" },
	LRFK0663: { color: "dimgray" },
	LRFK0665: { color: "dimgray" },
	LRFK0671: { color: "dimgray" },
	LRFK0678: { color: "dimgray" },
	LRFK0681: { color: "dimgray" },
	LRFK0686: { color: "dimgray" },
	LRFK0687: { color: "dimgray" },
	LRFK0712: { color: "dimgray" },
	LRFK0713: { color: "dimgray" },

	//
	// LRFK Milk Related KPIs
	//

	LRFKBoughtServicesForMilkingCows: { color: "dimgray" },
	LRFKCompanyOwnerSalaries: { color: "dimgray" },
	LRFKConcentrateFeedPerKiloMilk: { color: "dimgray" },
	LRFKContributionMarginPerKiloMilk: { color: "dimgray" },
	LRFKCostOfCareForMilkingCows: { color: "dimgray" },
	LRFKEmployeeSalaries: { color: "dimgray" },
	LRFKForageCostForMilkingCows: { color: "dimgray" },
	LRFKForagePerKiloMilk: { color: "dimgray" },
	LRFKKiloMilkPerAverageCow: { color: "dimgray" },
	LRFKKiloMilkPerAverageCowPerDay: { color: "dimgray" },
	LRFKKiloMilkPerDay: { color: "dimgray" },
	LRFKKiloMilkPerProducingCow: { color: "dimgray" },
	LRFKKiloMilkPerProducingCowPerDay: { color: "dimgray" },
	LRFKKiloMilkPerRobot: { color: "dimgray" },
	LRFKKiloMilkPerRobotPerDay: { color: "dimgray" },
	LRFKKiloMilkPerWorkingHour: { color: "dimgray" },
	LRFKReductionsForMilkingCows: { color: "dimgray" },
	LRFKRevenueAfterForageCostPerKiloMilk: { color: "dimgray" },
	LRFKTotalIncomeFromMilk: { color: "dimgray" },
	LRFKTotalNumberOfCows: { color: "dimgray" },
	LRFKTotalWorkedHours: { color: "dimgray" },
	LRFKUsageOfAvailableCowPlaces: { color: "dimgray" },
	LRFKWorkHoursPerCow: { color: "dimgray" },

	//
	// LRFK Piglet Related KPIs
	//

	LRFKBoughtServicesForPiglets: { color: "dimgray" },
	LRFKEmployeeSalariesPiglets: { color: "dimgray" },
	LRFKCostOfPersonnelForPiglets: { color: "dimgray" },
	LRFKLabourCostPiglets: { color: "dimgray" },
	LRFKKiloPiglet: { color: "dimgray" },
	LRFKLabourCostPerSoldPiglet: { color: "dimgray" },
	LRFKLabourCostPerKiloPiglet: { color: "dimgray" },
	LRFKSoldPiglet: { color: "dimgray" },
	LRFKWorkedHours: { color: "dimgray" },
	LRFKKiloPigletPerWorkHour: { color: "dimgray" },
	LRFKInternalForageCostPiglets: { color: "dimgray" },
	LRFKBoughtForageCostPiglets: { color: "dimgray" },
	LRFKForageCostPiglets: { color: "dimgray" },
	LRFKForageCostPerSoldPiglet: { color: "dimgray" },
	LRFKForageCostPerKiloPiglet: { color: "dimgray" },
	LRFKSettlementPricePiglets: { color: "dimgray" },
	LRFKIncomePiglets: { color: "dimgray" },
	LRFKTotalIncomePiglets: { color: "dimgray" },
	LRFKSettlementPriceMinusTotalForageCost: { color: "dimgray" },
	LRFKCostOfBoughtPiglets: { color: "dimgray" },
	LRFKCostOfCarePiglets: { color: "dimgray" },
	LRFKBreedingCostPiglets: { color: "dimgray" },
	LRFKHousingCostPiglets: { color: "dimgray" },
	LRFKTb3Piglets: { color: "dimgray" },
	LRFKContributionMarginPerSoldPiglet: { color: "dimgray" },
	LRFKEnergyCostPiglets: { color: "dimgray" },
	LRFKEnergyCostPerKiloPiglet: { color: "dimgray" },
	LRFKEnergyCostPerSoldPiglet: { color: "dimgray" },
	LRFKProtectiveWorkwearPerSoldPiglet: { color: "dimgray" },
	LRFKProductionCostIncludingLabourPiglets: { color: "dimgray" },
	LRFKProductionCostIncludingLabourPerKiloPiglet: { color: "dimgray" },
	LRFKProductionCostIncludingLabourPerSoldPiglet: { color: "dimgray" },
	LRFKMachineryAndTransportPiglets: { color: "dimgray" },
	LRFKCostOfMachineryAndTransportPiglets: { color: "dimgray" },
	LRFKIncomeFromMachineryAndTransportPiglets: { color: "dimgray" },
	LRFKNetLandLeasePiglets: { color: "dimgray" },
	LRFKFinancialCostPiglets: { color: "dimgray" },

	//
	// LRFK Slaughter Pig Related KPIs
	//

	LRFKBoughtServicesForSlaughterPigs: { color: "dimgray" },
	LRFKEmployeeSalariesSlaughterPigs: { color: "dimgray" },
	LRFKCostOfPersonnelForSlaughterPigs: { color: "dimgray" },
	LRFKLabourCostSlaughterPigs: { color: "dimgray" },
	LRFKTb3SlaughterPigs: { color: "dimgray" },
	LRFKIncomeSlaughterPigs: { color: "dimgray" },
	LRFKTotalIncomeSlaughterPigs: { color: "dimgray" },
	LRFKInternalForageCostSlaughterPigs: { color: "dimgray" },
	LRFKBoughtForageCostSlaughterPigs: { color: "dimgray" },
	LRFKForageCostSlaughterPigs: { color: "dimgray" },
	LRFKCostOfCareSlaughterPigs: { color: "dimgray" },
	LRFKHousingCostSlaughterPigs: { color: "dimgray" },
	LRFKMachineryAndTransportSlaughterPigs: { color: "dimgray" },
	LRFKCostOfMachineryAndTransportSlaughterPigs: { color: "dimgray" },
	LRFKIncomeFromMachineryAndTransportSlaughterPigs: { color: "dimgray" },
	LRFKNetLandLeaseSlaughterPigs: { color: "dimgray" },
	LRFKFinancialCostSlaughterPigs: { color: "dimgray" },
	LRFKProductionCostIncludingLabourSlaughterPigs: { color: "dimgray" },
	LRFKLabourCostPerKiloSoldPigMeat: { color: "dimgray" },
	LRFKContributionMarginPerKiloSoldPigMeat: { color: "dimgray" },
	LRFKForageCostPerKiloSoldPigMeat: { color: "dimgray" },
	LRFKTotalIncomeMinusForageCostPerKiloSoldPigMeat: { color: "dimgray" },
	LRFKProductionCostIncludingLabourPerKiloSoldPigMeat: {
		color: "dimgray",
	},
	LRFKKiloSoldPigMeatPerWorkHour: { color: "dimgray" },
	LRFKBreedingCostSlaughterPigs: { color: "dimgray" },
	LRFKCostOfBoughtSlaughterPigs: { color: "dimgray" },

	//
	// LRFK Crop Related KPIs
	//

	LRFKIncomePerHectare: { color: "dimgray" },
	LRFKDirectCostsPerHectare: { color: "dimgray" },
	LRFKGrossProfitPerHectare: { color: "dimgray" },
	LRFKCostOfMachineryPerHectare: { color: "dimgray" },
	LRFKLabourCostPerHectare: { color: "dimgray" },
	LRFKHiredPersonnelPerHectare: { color: "dimgray" },
	LRFKCost2PerHectare: { color: "dimgray" },
	LRFKContributionMarginPerHectare: { color: "dimgray" },
	LRFKProductionValueCrops: { color: "dimgray" },
	LRFKLabourCostAsPercentageOfProductionValue: { color: "dimgray" },
	LRFKCostOfMachineryAsPercentageOfProductionValue: { color: "dimgray" },
	LRFKHiredPersonnelAsPercentageOfProductionValue: { color: "dimgray" },
	LRFKProductionValuePer1800HoursOfWork: { color: "dimgray" },
	LRFKCostOfMachineryHectare: { color: "dimgray" },
	LRFKHectareUsedLandArea: { color: "dimgray" },
	LRFKCostOfSeeds: { color: "dimgray" },
	LRFKCostOfFertilizersAndPesticides: { color: "dimgray" },
	LRFKOtherDirectCostsCrops: { color: "dimgray" },
	LRFKDirectCostsCrops: { color: "dimgray" },
	LRFKInternalIncomeCrops: { color: "dimgray" },
	LRFKIncomeCrops: { color: "dimgray" },
	LRFKTotalIncomeCrops: { color: "dimgray" },
	LRFKOtherCostsCrops: { color: "dimgray" },
	LRFKGrossProfitCrops: { color: "dimgray" },
	LRFKCostOfFuel: { color: "dimgray" },
	LRFKCostOfMachineryMaintenance: { color: "dimgray" },
	LRFKOtherMachineryCosts: { color: "dimgray" },
	LRFKCostOfMachinery: { color: "dimgray" },
	LRFKBoughtServicesCrops: { color: "dimgray" },
	LRFKEmployeeSalariesCrops: { color: "dimgray" },
	LRFKLabourCostCrops: { color: "dimgray" },
	LRFKHiredPersonnelCrops: { color: "dimgray" },
	LRFKSoldServicesCrops: { color: "dimgray" },
	LRFKOverheadCostCrops: { color: "dimgray" },
	LRFKCost2Crops: { color: "dimgray" },
	LRFKTb2Crops: { color: "dimgray" },
	LRFKIndirectCostsCrops: { color: "dimgray" },
	LRFKSubsidiesCrops: { color: "dimgray" },
	LRFKIncomeFromLandLease: { color: "dimgray" },
	LRFKCostOfLandLease: { color: "dimgray" },
	LRFKNetLandLease: { color: "dimgray" },
	LRFKFinancialCostsCrops: { color: "dimgray" },
	LRFKLandCostCrops: { color: "dimgray" },
};
